export default "__VITE_ASSET__D9y2yBwS__"